/**
 * Founder/admin memorial product request queue API — Wave 4C1 lite.
 */
import axios from 'axios';
import { getApiBase } from './apiBase';

const API = getApiBase();

export const ADMIN_QUEUE_STATUS_LABELS = {
  submitted: { label: 'Submitted', description: 'Saved for review.' },
  reviewing: { label: 'Reviewing', description: 'Under internal review.' },
  needs_customer_info: { label: 'Needs customer info', description: 'Waiting on customer details.' },
  ready_for_payment_later: {
    label: 'Ready for payment (later)',
    description: 'Approved for review — payment is not live yet.',
  },
  cancelled: { label: 'Cancelled', description: 'Request cancelled.' },
  completed_manually: { label: 'Completed manually', description: 'Handled outside the app.' },
};

export const ADMIN_QUEUE_STATUSES = Object.keys(ADMIN_QUEUE_STATUS_LABELS);

export function adminQueueStatusCopy(status) {
  return ADMIN_QUEUE_STATUS_LABELS[status] || ADMIN_QUEUE_STATUS_LABELS.submitted;
}

export async function listAdminMemorialProductRequests({ status, limit = 100 } = {}) {
  const params = { limit };
  if (status) params.status = status;
  const res = await axios.get(`${API}/admin/memorial-product-requests`, { params });
  return res.data;
}

export async function getAdminMemorialProductRequest(requestId) {
  const res = await axios.get(`${API}/admin/memorial-product-requests/${requestId}`);
  return res.data;
}

export async function updateAdminMemorialProductRequestStatus(requestId, status) {
  const res = await axios.patch(`${API}/admin/memorial-product-requests/${requestId}/status`, { status });
  return res.data;
}

export async function updateAdminMemorialProductRequestNotes(requestId, adminNotes) {
  const res = await axios.patch(`${API}/admin/memorial-product-requests/${requestId}/notes`, {
    admin_notes: adminNotes,
  });
  return res.data;
}
